import { ForwardedRef, forwardRef, useContext } from 'react'
import { Renderable } from '../classes/renderer'
import { ArtboardContext } from '../context'
import { useSprite } from '../hooks/use-sprite'
import { ArtboardGifLayerProps } from '../types'
import ArtboardSprite from './sprite'

const ArtboardGif = ({ source, ...rest }: ArtboardGifLayerProps, ref: ForwardedRef<Renderable>) => {
    const { fps } = useContext(ArtboardContext)
    const sprite = useSprite(source, fps)

    return <ArtboardSprite {...rest} ref={ref} source={sprite} />
}

export default forwardRef(ArtboardGif)
